<script setup lang="ts">
import coatOfArms from "@/assets/coat_of_arms.png"
</script>

<template>
  <div class="bg-[#3b7cbd] text-white text-sm py-2">
    <div class="max-w-[1200px] mx-auto px-4 flex justify-between items-center">
      <div class="flex items-center gap-2">
        <img :src="coatOfArms" alt="Coat of Arms" class="h-7 w-auto">
        <span class="text-white/90 text-xs sm:text-sm">Government of the Republic of Uganda</span>
      </div>
      <div class="flex items-center gap-4">
        <a href="#" class="text-white/80 hover:text-white transition" aria-label="Facebook">
          <svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor">
            <path d="M14 13.5h2.5l1-4H14v-2c0-1.03 0-2 2-2h1.5V2.14c-.326-.043-1.557-.14-2.857-.14C11.928 2 10 3.657 10 6.7v2.8H7v4h3V22h4v-8.5z" />
          </svg>
        </a>
        <a href="#" class="text-white/80 hover:text-white transition" aria-label="Twitter/X">
          <svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor">
            <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
          </svg>
        </a>
      </div>
    </div>
  </div>
</template>
